import { ChangeEvent } from 'react';

import { Select } from '@atom/mui';
import colors from '@atom/styles/colors';
import { ConversionUnit } from '@atom/types/schema';

import classes from './costTab.module.css';

const { MenuItem } = Select;

const styles = {
  select: {
    width: '6.25rem',
  },
  selectInput: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.neutral.silver,
    },
    color: colors.neutral.dark,
    textTransform: 'uppercase',
    '& .MuiSelect-select': {
      padding: '0.25rem 0.5rem',
      lineHeight: '1.25rem',
    },
  },
  option: {
    textTransform: 'uppercase',
  },
};

type ConversionUnitSelectorProps = {
  baseUnit?: string;
  conversionUnits: ConversionUnit[];
  selectedConversionUnit?: ConversionUnit;
  onChange: (conversionUnitId: string) => void;
};

const ConversionUnitSelector = ({
  baseUnit,
  conversionUnits,
  selectedConversionUnit,
  onChange,
}: ConversionUnitSelectorProps) => (
  <div className={classes.conversionUnitSelector}>
    <span className={classes.conversionUnitLabel}>Conversion Unit:</span>
    <Select
      variant="outlined"
      style={styles.select}
      inputSx={styles.selectInput}
      value={selectedConversionUnit?.id ?? ''}
      // the menu shows each conversion so two units with the same name can be told apart
      renderValue={(id: string) =>
        conversionUnits.find(conversionUnit => conversionUnit.id === id)?.unit
      }
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        onChange(event.target.value)
      }
      data-cy="costTabConversionUnitSelect"
    >
      {conversionUnits.map(conversionUnit => (
        <MenuItem
          key={conversionUnit.id}
          value={conversionUnit.id}
          style={styles.option}
          data-cy={`costTabConversionUnitOption-${conversionUnit.unit}`}
        >
          {`${conversionUnit.unit} (${conversionUnit.conversionNumber} ${baseUnit})`}
        </MenuItem>
      ))}
    </Select>
    {selectedConversionUnit && (
      <span
        className={classes.conversionUnitDescription}
        data-cy="costTabConversionUnitDescription"
      >
        {`(1 ${selectedConversionUnit.unit} = ${selectedConversionUnit.conversionNumber} ${baseUnit})`}
      </span>
    )}
  </div>
);

export default ConversionUnitSelector;
